export default "__VITE_ASSET__D_yYB_fT__"